import * as p from '@clack/prompts'
import type { SchemaField, SchemaTab } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { deriveAvailableFieldName } from '../schema-prompts/derive-available-field-name.js'
import { getFieldNames } from '../schema-prompts/get-field-names.js'
import { promptSelectValue } from '../schema-prompts/prompt-select-value.js'
import { promptText } from '../schema-prompts/prompt-text.js'
import { promptAdditionalSchemaFields } from './prompt-additional-schema-fields.js'
import { promptTabSlotFields } from './prompt-tab-slot-fields.js'

export async function promptSchemaTab(
  kind: 'entity' | 'single',
  schemasDir: string,
  titleField: SchemaField | undefined,
  existingTabs: SchemaTab[]
): Promise<SchemaTab> {
  const label = await promptText(
    CREATE_PROMPT_CONTEXT,
    'Tab label',
    titleField ? 'Content' : undefined
  )
  const name = deriveAvailableFieldName(label, getFieldNames(existingTabs))
  const layout = await promptSelectValue(CREATE_PROMPT_CONTEXT, 'Tab layout', [
    { value: 'fields', label: 'Single fields array' },
    { value: 'slot', label: 'Main/sidebar slots' }
  ] as const)

  if (layout === 'fields') {
    const fields: SchemaField[] = titleField ? [titleField] : []
    if (titleField) {
      await promptAdditionalSchemaFields(kind, schemasDir, fields)
    } else {
      while (fields.length === 0) {
        await promptAdditionalSchemaFields(kind, schemasDir, fields)
        if (fields.length === 0) {
          p.log.warn('Tabs need at least one child field.')
        }
      }
    }
    return { name, label, fields }
  }

  const slotFields = await promptTabSlotFields(kind, schemasDir, titleField)
  return {
    name,
    label,
    slot: {
      ...(slotFields.main.length > 0 ? { main: { fields: slotFields.main } } : {}),
      ...(slotFields.sidebar.length > 0 ? { sidebar: { fields: slotFields.sidebar } } : {})
    }
  }
}
